import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        screenWidth: '1200',
    },
    mutations: {
        // 保存当前菜单栏的路径
        Width(state, screenWidth) {
            state.screenWidth = screenWidth;
        },
    },
});
